import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './scss/style.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import OneTimeCheckList from './components/Order/OneTimeCheckList';
import { getOrdersCountByResult } from './actions/orderActions';
import { getUserWithJwt } from './actions/userActions';
import ApiHelper from './api/apiCallsHelper';
import config from './common/config';

const App = () => {
  const dispatch = useDispatch();
  const ordersCount = useSelector(state => state.orderReducer.ordersCount);
  const user = useSelector(state => state.userReducer.user);

  const [oneTimeOrders, setOneTimeOrders] = useState(0);
  const [userInfo, setUserInfo] = useState({
    id: 0,
    fullName: '',
    preHireLimit: 0
  });

  useEffect(() => {
    dispatch(getOrdersCountByResult());
    dispatch(getUserWithJwt());

    const fetchOneTimeOrders = async () => {
      try {
        const result = await ApiHelper.postWithJWT(
          `${config.trueFingerPrintsAPI.baseURL}/orders/orders-limit`
        );
        setOneTimeOrders(result.data.count);
      } catch (error) {
        console.error('Failed to fetch one-time orders:', error);
      }
    };

    fetchOneTimeOrders();
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      setUserInfo({
        id: user.Id,
        fullName: user.fullName,
        preHireLimit: user.preHireLimit
      });
    }
  }, [user]);

  const remainingLimit = userInfo.preHireLimit - oneTimeOrders;

  let notice = null;
  if (userInfo.preHireLimit === 0) {
    notice = (
      <Row>
        <Col>
          <h5 className='py-5 mx-5 mt-4 notice'>
            <i className='material-icons'>warning</i>
            Account Restricted: This account does not have an active plan or FCRA compliance validation.
            Please send an email to: support@personnelgraph.net.
          </h5>
        </Col>
      </Row>
    );
  } else if (remainingLimit >= 5) {
    notice = (
      <Row>
        <Col>
          <h5 className='py-5 mx-5 mt-4 notice-success'>
            <i className='material-icons'>check_circle</i>
            Account Plan: Active -  {remainingLimit} CourtRequest and unlimited Authorizations remaining. For renewal, contact your CSM
          </h5>
        </Col>
      </Row>
    );
  } else if (remainingLimit < 5) {
    notice = (
      <Row>
        <Col>
          <h5 className='py-5 mx-5 mt-4 notice-alert'>
            <i className='material-icons'>warning</i>
            Account Plan: Active - {remainingLimit}  CourtRequest and unlimited Authorizations remaining. For renewal, contact your CSM
          </h5>
        </Col>
      </Row>
    );
  }

  return (
    <Container fluid>
      <Row>
        <Col className='header-stats' lg={12}>
          <section className='results mt-5 mb-5'>
            <article className='clear'>
              <h1 className='clear-colorize'>
                {ordersCount?.clear || 0}
              </h1>
              <h4>Clear Results</h4>
              <Link to='/results/clear'>
                <Button variant='link'>
                  <i className='material-icons'>search</i>View All
                </Button>
              </Link>
            </article>
            <article className='alerts'>
              <h1 className='alert-colorize'>
                {ordersCount?.alert || 0}
              </h1>
              <h4>Results with Alerts</h4>
              <Link to='/results/alerts'>
                <Button variant='link'>
                  <i className='material-icons'>search</i>View All
                </Button>
              </Link>
            </article>
            <article className='awaiting'>
              <h1 className='awaiting-colorize'>
                {ordersCount?.pending || 0}
              </h1>
              <h4>Awaiting Info</h4>
              <Link to='/results/awaiting'>
                <Button variant='link'>
                  <i className='material-icons'>search</i>View All
                </Button>
              </Link>
            </article>
          </section>
        </Col>
      </Row>
      {notice}
      <Row className='button-action text-center'>
        <Col className='text-group' lg={12}>
          <Link to='/authorization'>
            <Button variant='success' size='lg' className='mr-2'>
              <i className='material-icons'>playlist_add</i>Start Authorization
            </Button>
          </Link>
          <Link to='/individuals'>
            <Button variant='success' size='lg'>
              <i className='material-icons'>fingerprint</i>Start Screening
            </Button>
          </Link>
        </Col>
      </Row>

      <OneTimeCheckList />
    </Container>
  );
};

export default App;
